import { format } from 'date-fns';
import type { RepCardFilters } from './repCardFilters';

const formatDay = (value: string): string | null => {
	const date = new Date(`${value}T00:00:00`);
	return Number.isNaN(date.getTime()) ? null : format(date, 'MMM d');
};

const range = (min: string, max: string, describe: (bounds: string) => string, suffix = ''): string | null => {
	const from = min.trim();
	const to = max.trim();
	if (from && to) {
		return describe(`${from}–${to}${suffix}`);
	}
	if (from) {
		return describe(`${from}+${suffix}`);
	}
	if (to) {
		return describe(`≤${to}${suffix}`);
	}
	return null;
};

/**
 * One short chip per active filter, so a collapsed filter bar still says what it is hiding — a card
 * showing 2 of a rep's 40 calls must never look unfiltered.
 */
export function summarizeRepCardFilters(filters: RepCardFilters): string[] {
	const chips: string[] = [];

	const score = range(filters.minScore, filters.maxScore, bounds => `Score ${bounds}`);
	if (score) {
		chips.push(score);
	}

	const length = range(filters.minMinutes, filters.maxMinutes, bounds => bounds, ' min');
	if (length) {
		chips.push(length);
	}

	const start = filters.startDate.trim() ? formatDay(filters.startDate.trim()) : null;
	const end = filters.endDate.trim() ? formatDay(filters.endDate.trim()) : null;
	if (start && end) {
		chips.push(`${start} – ${end}`);
	} else if (start) {
		chips.push(`From ${start}`);
	} else if (end) {
		chips.push(`Until ${end}`);
	}

	return chips;
}
